import React, {useEffect, useState} from 'react';
import Recipe from './recipe';
import logo from './logo.svg';
import './App.css';

const App = () => {
  const APP_ID = "56a7d2d4";
  const APP_KEY = "c30488e8f17b706a298ac97b017c4f80";

  const [recipes, setRecipes] = useState([]);
  const [search, setSearch] = useState('');
  const [query, setQuery] = useState('chicken');

  useEffect(() => {
    getRecipes();
  },[query]);

  const getRecipes = async () => {
  const response = await fetch(`https://api.edamam.com/search?q=${query}&app_id=${APP_ID}&app_key=${APP_KEY}`);
  const data = await response.json();
  setRecipes(data.hits);
  console.log(data.hits);
  }

  const updateSearch = ent => {
    setSearch(ent.target.value);
  }

  const getSearch = ent => {
    ent.preventDefault();
    setQuery(search);
    setSearch('');
  }

  return (
    <div className="App">
     <form onSubmit={getSearch} className="search-form">
        <input className='search-bar' 
        type="text" 
        value={search} 
        onChange={updateSearch}/>
        <button className ='search-btn' type="submit">
        Search
        </button>
     </form>
     <div className='recipes'>
     {recipes.map(recipe => (
      <Recipe 
      key={recipe.recipe.label}
      title={recipe.recipe.label} 
      calories={recipe.recipe.calories} 
      image={recipe.recipe.image}
      ingredients={recipe.recipe.ingredients}
      />
     ))}
     </div>
    </div>
  );
}
export default App;